'use client';
import React, { useEffect } from 'react';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import NotifierCarousel from '../../../../components/notifierCarousel/notifierCarousel';
import NotifierCard from './components/notifierCard/notifierCard';
import { useNotifierCard } from './notifierCard.controller';
import { useGeneralContext } from '@/contexts/general/general.context';

const NeedsYourAttention = () => {
  const { policies, claims } = useGeneralContext();
  const { generateNotifierList } = useNotifierCard();
  const {
    finalNotifiers,
    dashboardLabels,
    setFinalNotifiers,
    emiRecoveryNotifier,
    showBanner,
  } = useDashboard();

  useEffect(() => {
    if (policies.value && claims.value) {
      generateNotifierList(
        policies.value,
        claims.value,
        emiRecoveryNotifier,
        showBanner
      );
    }
    if (policies.error || claims.error) {
      setFinalNotifiers([]);
    }
  }, [policies, claims, emiRecoveryNotifier, showBanner]);

  return (
    <NotifierCarousel
      title={dashboardLabels.needsYourAttentionCmsData.title}
      Component={NotifierCard}
      cards={finalNotifiers}
      autoPlay={true}
    />
  );
};

export default NeedsYourAttention;
